<template>
  <div class="login-container">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" autocomplete="on" label-position="left">

      <div class="title-container">
        <h3 class="title">
          <img src="@/assets/image/diy-log.png" alt="" style="width: 32px;height: 32px">
          {{ $t('login.title') }}
        </h3>
        <lang-select class="set-language" />
      </div>

      <el-form-item prop="username">
        <span class="svg-container">
          <svg-icon icon-class="diy-user" class="big-icon" />
        </span>
        <div class="line" />
        <el-input
          ref="username"
          v-model="loginForm.username"
          :placeholder="$t('login.username')"
          name="username"
          type="text"
          tabindex="1"
          autocomplete="off"
        />
      </el-form-item>

      <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
        <el-form-item prop="password">
          <span class="svg-container">
            <svg-icon icon-class="diy-password" class="big-icon" />
          </span>
          <div class="line" />
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            :placeholder="$t('login.password')"
            name="password"
            tabindex="2"
            autocomplete="off"
            @keyup.native="checkCapslock"
            @blur="capsTooltip = false"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="passwordType === 'password' ? 'diy-eye' : 'diy-eye-open'" />
          </span>
        </el-form-item>
      </el-tooltip>

      <el-form-item prop="captcha">
        <span class="svg-container">
          <svg-icon icon-class="diy-question" class="big-icon" />
        </span>
        <div class="line" />
        <el-input
          ref="captcha"
          v-model="loginForm.captcha"
          :placeholder="$t('login.captcha')"
          name="captcha"
          type="text"
          tabindex="3"
          autocomplete="off"
          class="captcha-input"
          @keydown.enter.native="handleLogin"
        />

        <el-tooltip effect="light" :content="$t('login.refreshCaptchaTip')" placement="top">
          <span class="captcha-img" @click="refreshCaptcha">
            <img :src="captchaImg" :title="$t('login.refreshCaptcha')">
          </span>
        </el-tooltip>
      </el-form-item>

      <el-button
        :loading="loading"
        type="primary"
        style="width:100%;margin-top:30px;height: 54px;border-radius: 8px;font-size: 16px"
        @click="handleLogin"
      >
        {{ $t('login.logIn') }}
      </el-button>
      <el-button
        type="success"
        plain
        style="width:100%;margin-top:12px;height: 44px;border-radius: 8px;margin-left: 0;"
        @click="handleCasdoorLogin"
      >
        Casdoor 第三方登录
      </el-button>
      <!-- <el-button
        type="primary"
        style="width:100%;margin-left:0px"
        @click="scanningcode"
      >
        扫码登录
      </el-button> -->
    </el-form>
    <div v-if="dialogVisible" class="ifar_box">
      1111
      <div v-if="dialogVisible" id="login_container" style="width:300px;height:300px" />
    </div>

    <div class="icp-footer">
      海南静轩网络科技有限公司惠州市分公司 ICP备案/许可证号：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">粤ICP备2021128628号-1</a>
    </div>

    <!-- 绑定钉钉弹窗 -->
    <el-dialog
      title="绑定钉钉账号"
      :visible.sync="bindDingdingDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="text-align: center; padding: 20px 0;">
        <p style="font-size: 16px; margin-bottom: 20px;">您的账号尚未绑定第三方账号，请先绑定第三方账号</p>
        <el-button
          type="primary"
          size="medium"
          :loading="bindLoading"
          @click="handleBindDingding"
        >
          前往绑定第三方账号
        </el-button>
        <el-button
          type="text"
          size="medium"
          style="margin-top: 12px; display: block; width: 100%;"
          @click="handleSkipBind"
        >
          暂时跳过
        </el-button>
      </div>
    </el-dialog>

    <!-- 选择管理员弹窗 -->
    <el-dialog
      title="已绑定多个登录账号，请选择需要登录的账号"
      :visible.sync="adminListDialogVisible"
      width="700px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div v-loading="adminListLoading">
        <el-table
          :data="adminList"
          border
          style="width: 100%"
          max-height="400"
          @row-click="handleSelectAdmin"
        >
          <el-table-column
            prop="name"
            label="用户名"
            align="center"
          />
          <el-table-column
            prop="realName"
            label="姓名"
            align="center"
          />
          <el-table-column
            label="操作"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                :loading="scope.row.switching"
                @click.stop="handleSelectAdmin(scope.row)"
              >
                选择账号
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>

// 配置数据
// var domain = 'http://jdj8fq.natappfree.cc/' // 这里要改：这个飞书等下要重定向的地址，要改成你的
// var backUrl = domain
var config = {
  client_id: 'cli_a2dc74533c78500d', // 用你的App ID替换
  client_secret: 'Otm3Rk0hJGMpwO2lLOgh5e0rIrx7epHh', // 用你的App Secret
  // redirect_uri: backUrl
  redirect_uri: ''
}
// const origin = window.location.origin
import { validUsername } from '@/utils/validate'
import LangSelect from '@/components/LangSelect'
import { mapGetters } from 'vuex'
import { getFeiShuLoginappInfo } from '@/api/sourceMaterial.js'
import { setToken, setRefreshToken, setTokenExpiresIn } from '@/utils/auth'
import { getCasdoorAdminList, switchCasdoorAdmin } from '@/api/passport'
// import { dingdingauthurl } from '@/api/workWechat.js'
export default {

  name: 'Login',
  components: { LangSelect },
  computed: {
    ...mapGetters(['roles'])
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error('Please enter the correct user name'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('The password can not be less than 6 digits'))
      } else {
        callback()
      }
    }
    const validateCaptcha = (rule, value, callback) => {
      if (value.length !== 4) {
        callback(new Error('The captcha must 4 digits'))
      } else {
        callback()
      }
    }
    return {
      captchaImg: require('@/assets/larke/captcha.png'),
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        captchaKey: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        captcha: [{ required: true, trigger: 'blur', validator: validateCaptcha }]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      dialogVisible: false,
      bindDingdingDialogVisible: false,
      bindLoading: false,
      currentToken: null,
      // 管理员选择相关
      adminListDialogVisible: false,
      adminListLoading: false,
      adminList: [],
      casDoorToken: null
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  created() {
    console.log('登录this.$route.query.token', this.$route.query)
    // Casdoor 方案：第三方登录成功后回调到 /login?token=xxx&redirect=...
    this.handleTokenFromQuery()
    // window.addEventListener('storage', this.afterQRScan)
    this.refreshCaptcha()
    // this.getFeiShuLoginAppInfoall()
  },
  mounted() {
    window.aa = this
    if (this.loginForm.username === '') {
      this.$refs.username.focus()
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus()
    } else if (this.loginForm.captcha === '') {
      this.$refs.captcha.focus()
    }
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    scanningcode() {
      this.dialogVisible = !this.dialogVisible
      this.getFeiShuLoginAppInfoall()
      // this.getQrCode()
    },
    // 获取扫码登录接口
    async getFeiShuLoginAppInfoall() {
      const data = await getFeiShuLoginappInfo()
      config.redirect_uri = data.data.fei_shu_login_info.redirect_uri
      config.client_id = data.data.fei_shu_login_info.client_id
      this.getQrCode()
    },
    getQrCode() {
      console.log('-------调起扫码----', config.client_id, config.redirect_uri)

      // 调起扫码
      var goto = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=${config.client_id}&redirect_uri=${config.redirect_uri}&response_type=code&state=state123456`

      // 利用前端网页跳转
      // window.location.href = url;
      // eslint-disable-next-line no-undef
      var QRLoginObj = QRLogin({
        id: 'login_container',
        goto,
        // goto: "https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a03f23493d39d00e&redirect_uri=https%3A%2F%2Fwww.baidu.com&response_type=code&state=STATE",
        width: '300',
        height: '300'
      })
      var handleMessage = function(event) {
        console.error('event', event)
        var origin = event.origin
        // 使用 matchOrigin 方法来判断 message 是否来自飞书页面
        if (QRLoginObj.matchOrigin(origin)) {
          var loginTmpCode = event.data
          // 在授权页面地址上拼接上参数 tmp_code，并跳转
          window.location.href = `${goto}&tmp_code=${loginTmpCode}`
          console.log(loginTmpCode)
        }
      }
      if (typeof window.addEventListener !== 'undefined') {
        window.addEventListener('message', handleMessage, false)
      } else if (typeof window.attachEvent !== 'undefined') {
        window.attachEvent('onmessage', handleMessage)
      }
      // 原文链接：https://blog.csdn.net/xutongbao/article/details/123278795
    },
    checkCapslock(e) {
      const { key } = e
      this.capsTooltip = key && key.length === 1 && (key >= 'A' && key <= 'Z')
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    refreshCaptcha() {
      this.$store.dispatch('user/captcha')
        .then(response => {
        //  console.log(response, 'response')
          const headers = response.headers
          const res = response.data
          const captchaKey = headers['admin-captcha-id']
          const captchaImg = res.data.captcha
          this.loginForm.captchaKey = captchaKey
          this.captchaImg = captchaImg
        })
        .catch(err => {
          return err // return false 报错，改为了 return err
        })
    },
    handleLogin() {
      // this.$refs.loginForm.validate(valid => {
      //   if (valid) {
      //     this.loading = true
      //     // console.log('this.loginForm', this.loginForm)
      //     this.$store.dispatch('user/login', this.loginForm)
      //       .then(response => {
      //         setTimeout(() => {
      //           console.log(this.roles.length ? this.redirect || '/' : '/dashboard/index', '+++')
      //           this.$router.push({ path: this.roles.length ? this.redirect || '/' : '/dashboard/index', query: this.otherQuery })
      //           this.loading = false
      //         }, 500)
      //       })
      //       .catch(err => {
      //         this.$message({
      //           message: err.message || 'Error',
      //           type: 'error',
      //           duration: 2 * 1000
      //         })

      //         this.refreshCaptcha()

      //         this.loading = false
      //       })
      //   } else {
      //     console.log('error submit!!')
      //     return false
      //   }
      // })
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('user/login', this.loginForm)
            .then(data => {
              console.log('登录返回数据:', data)
              // 检查是否绑定钉钉
              // store 返回的是 data，不是 response.data
              const isBindDingding = data?.cas_door_id
              const token = this.$store.getters.token || data?.access_token

              // 保存当前 token，用于后续绑定
              this.currentToken = token

              console.log('isBindDingding:', isBindDingding, 'token:', token)

              // eslint-disable-next-line eqeqeq
              if (isBindDingding == '') {
                // 未绑定，显示弹窗
                this.loading = false
                this.bindDingdingDialogVisible = true
              } else {
                // 已绑定，跳转首页
                // this.$router.push({ path: '/' })
                this.$router.push({ path: this.roles.length ? this.redirect || '/' : '/dashboard/index', query: this.otherQuery })
                this.loading = false
              }
            })
            .catch(err => {
              this.$message({
                message: err.message || 'Error',
                type: 'error',
                duration: 2 * 1000
              })

              this.refreshCaptcha()

              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 绑定钉钉
    handleBindDingding() {
      console.log('2222222')
      if (!this.currentToken) {
        this.$message.error('登录信息已失效，请重新登录')
        this.bindDingdingDialogVisible = false
        return
      }

      this.bindLoading = true
      // dingdingauthurl({
      //   redirect_uri: window.location.origin
      // }).then((res) => {
      //   const authUrl = res.data.auth_url
      //   // 在地址后面拼接 token
      //   const separator = authUrl.includes('?') ? '&' : '?'
      //   const finalUrl = `${authUrl}${separator}ad_access_token=${encodeURIComponent(this.currentToken)}`
      //   console.log('finalUrl', finalUrl)
      //   console.log('跳转到绑定页面:', finalUrl)
      //   // window.location.href = finalUrl
      // }).catch(err => {
      //   this.$message.error('获取绑定地址失败，请重试', err)
      //   this.bindLoading = false
      // })
      console.log('encodeHost', this.encodeHost(window.location.origin))
      console.log('process.env.VUE_APP_BACKUP_API_URL', `${process.env.VUE_APP_BACKUP_API_URL}/auth/casdoor?access_token=${this.currentToken}&host=${this.encodeHost(window.location.origin)}`)
      window.location.href = `${process.env.VUE_APP_BACKUP_API_URL}/auth/casdoor?access_token=${this.currentToken}&host=${this.encodeHost(window.location.origin)}`
    },
    // 暂时跳过绑定
    handleSkipBind() {
      // 关闭弹窗
      this.bindDingdingDialogVisible = false
      // 执行正常登录后的跳转逻辑
      this.$router.push({ path: this.roles.length ? this.redirect || '/' : '/dashboard/index', query: this.otherQuery })
    },
    encodeHost(host) {
      return encodeURIComponent(
        btoa(unescape(encodeURIComponent(host)))
      )
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    // Casdoor 登录按钮：跳转到后端给的第三方地址
    handleCasdoorLogin() {
      // 如果后端需要带回跳地址/redirect，请按后端约定拼参数
      // 这里默认使用当前登录页作为回跳地址，带上 redirect（若有）
      // const redirect = this.redirect ? encodeURIComponent(this.redirect) : encodeURIComponent('/')
      // const back = encodeURIComponent(`${window.location.origin}/#/login?redirect=${redirect}`)
      // // 常见参数名：redirect_uri / returnUrl / callback 等；若你后端另有约定，改这里即可
      // const url = `https://casdoor-dev.xueynet.com/?redirect_uri=${back}`
      // console.log('url', url)
      // window.location.href = url

      // console.log('window.location.origin', window.location.origin)
      // dingdingauthurl({
      //   redirect_uri: window.location.origin
      // }).then((res) => {
      //   console.log('res', res.data.auth_url)
      //   window.location.href = res.data.auth_url
      // })
      window.location.href = `${process.env.VUE_APP_BACKUP_API_URL}/auth/casdoor?host=${this.encodeHost(window.location.origin)}`
    },
    // 从地址栏读取 token 并写入系统登录态
    handleTokenFromQuery() {
      // 从 window.location.search 中解析参数（处理 hash 前的查询参数）
      const urlParams = new URLSearchParams(window.location.search)
      const routeQuery = this.$route && this.$route.query ? this.$route.query : {}

      // 优先检查 error 参数（从 URL 查询参数或路由查询参数）
      let errorMsg = urlParams.get('error') || routeQuery.error
      if (errorMsg) {
        // 解码 URL 编码的错误信息
        try {
          errorMsg = decodeURIComponent(errorMsg)
        } catch (e) {
          // 如果解码失败，使用原始值
          console.warn('解码 error 参数失败:', e)
        }
        // 提示错误信息
        this.$message({
          message: errorMsg || '登录失败',
          type: 'error',
          duration: 5 * 1000
        })
        // 清理 URL 中的 error 和 access_token 参数
        const redirect = routeQuery.redirect || '/'
        const cleanUrl = window.location.origin + window.location.pathname + (redirect ? `#${redirect}` : '#/')
        window.history.replaceState({}, '', cleanUrl)
        // 如果有 redirect，跳转；否则停留在登录页
        if (redirect && redirect !== '/') {
          this.$router.replace({ path: redirect })
        }
        return
      }

      // 检查 cas_door_token 参数（在 error 检查之后）
      const casDoorToken = urlParams.get('cas_door_token') || routeQuery.cas_door_token
      if (casDoorToken) {
        this.casDoorToken = casDoorToken
        // 获取管理员列表
        this.fetchAdminList(casDoorToken)
        return
      }

      // 优先从 URL 查询参数中获取 access_token（hash 前的参数）
      let token = urlParams.get('access_token')
      let expiresIn = urlParams.get('expires_in')
      let refreshToken = urlParams.get('refresh_token')

      // 如果 URL 查询参数中没有，则从路由查询参数中获取（hash 后的参数）
      if (!token) {
        token = routeQuery.access_token
        expiresIn = routeQuery.expires_in
        refreshToken = routeQuery.refresh_token
      }

      console.log('token from URL:', token)
      // 如果 token 为空或只有空字符串，不处理
      if (!token || token.trim() === '') return

      // 写入本地 token（与你现有体系一致）
      const now = Date.parse(new Date()) / 1000
      const finalExpiresIn = parseInt(expiresIn || 7200) + now
      setToken(token)
      setTokenExpiresIn(finalExpiresIn)
      // 你项目里 refresh_token 有时也直接存 token，这里兼容一下
      setRefreshToken(refreshToken || token)

      // 同步到 vuex（避免本次会话里 store.getters.token 为空）
      this.$store.commit('user/SET_TOKEN', token)
      this.$store.commit('user/SET_EXPIRED_IN', finalExpiresIn)
      this.$store.commit('user/SET_REFRESH_TOKEN', refreshToken || token)

      // 清理 url 上的 token，避免泄露/被复制
      // 从 hash 后的路由查询参数中获取 redirect
      const redirect = routeQuery.redirect || '/'

      // 清理 URL 中的查询参数，只保留 hash 路由
      const cleanUrl = window.location.origin + window.location.pathname + (redirect ? `#${redirect}` : '#/')
      window.history.replaceState({}, '', cleanUrl)

      this.$router.replace({ path: redirect })
    },
    // 获取管理员列表
    fetchAdminList(casDoorToken) {
      this.adminListLoading = true
      this.adminList = []
      getCasdoorAdminList({ cas_door_token: casDoorToken })
        .then(response => {
          this.adminList = response.data.admin_list || []
          if (this.adminList.length === 0) {
            this.$message.warning('暂无可用管理员')
            return
          }
          // 显示选择弹窗
          this.adminListDialogVisible = true
        })
        .catch(err => {
          this.$message.error(err.message || '获取管理员列表失败')
        })
        .finally(() => {
          this.adminListLoading = false
        })
    },
    // 选择管理员
    handleSelectAdmin(row) {
      if (!this.casDoorToken) {
        this.$message.error('登录信息已失效，请重新登录')
        return
      }
      // 设置切换中状态
      this.$set(row, 'switching', true)
      switchCasdoorAdmin({
        cas_door_token: this.casDoorToken,
        admin_id: row.admin_id
      })
        .then(response => {
          const data = response.data || {}
          const token = data.access_token
          if (!token) {
            this.$message.error('获取登录凭证失败')
            return
          }
          // 写入本地 token（与你现有体系一致）
          const now = Date.parse(new Date()) / 1000
          const expiresIn = parseInt(data.expires_in || 7200) + now
          setToken(token)
          setTokenExpiresIn(expiresIn)
          setRefreshToken(data.refresh_token || data.token || token)

          // 同步到 vuex
          this.$store.commit('user/SET_TOKEN', token)
          this.$store.commit('user/SET_EXPIRED_IN', expiresIn)
          this.$store.commit('user/SET_REFRESH_TOKEN', data.refresh_token || data.token || token)

          // 关闭弹窗
          this.adminListDialogVisible = false
          // 清理 URL 中的 cas_door_token 参数
          const routeQuery = this.$route && this.$route.query ? this.$route.query : {}
          const redirect = routeQuery.redirect || '/'
          const cleanUrl = window.location.origin + window.location.pathname + (redirect ? `#${redirect}` : '#/')
          window.history.replaceState({}, '', cleanUrl)

          // 跳转到首页
          this.$router.replace({ path: redirect })
        })
        .catch(err => {
          this.$message.error(err.message || '切换管理员失败')
        })
        .finally(() => {
          this.$set(row, 'switching', false)
        })
    }

  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg:#FFFFFF;
$light_gray:#000;
$cursor: #000;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
    width: 290px;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 0;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid #E5E6EB;
    margin-bottom: 30px;
    border-radius: 8px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>

$dark_gray:#889aa4;
$light_gray:#1D2129;

.login-container {
  position: relative;
  min-height: 100%;
  width: 100%;
  background-image: url("~@/assets/login/bkg.png");
  overflow: hidden;
  background-size: cover; /* ⭐⭐ 关键 */
  background-position: center; /* ⭐⭐ 让图片居中显示 */
  background-repeat: no-repeat; /* 不重复 */

  .login-form {
    position: absolute;
    transform: translate(0%, 50%);
    right: 280px;
    width: 516px;
    height: 560px;
    background-color: #FFFFFF;
    border-radius: 24px;
    max-width: 100%;
    padding: 80px 70px 0;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 4px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    .big-icon {
      width: 1.2em;
      height: 1.2em;
    }
  }

  .title-container {
    position: relative;

    .title {
      font-size: 24px;
      color: $light_gray;
      margin: 0 auto 40px auto;
      text-align: center;
      font-weight: bold;

      display: flex; // 开启 flex 布局
      align-items: center; // 垂直居中
      justify-content: center; // 水平居中

      img {
        margin-right: 8px; // 图片和文字之间留点空隙
      }
    }

    .set-language {
      color: #fff;
      position: absolute;
      top: 3px;
      font-size: 18px;
      right: 0px;
      cursor: pointer;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 12px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  .captcha-input {
    width: 65%;
  }
  .captcha-img {
    width: 100px;
    height: 39px;
    vertical-align: middle;
    display: inline-block;
    position: absolute;
    top: 5px;
    right: 10px;
  }
  .captcha-img img {
    width: 100px;
    cursor: pointer;
  }
  .ifar_box{
    position: fixed;
    left: 73%;
    top: 41%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
  .line {
    width: 1px;
    height: 18px; // 我建议高度稍微拉高一点，接近图标和输入框高度
    background-color: #E5E6EB;
    display: inline-block;
    margin:0 10px; // 添加左右间距
    vertical-align: middle; // 保证和图标、输入框对齐
  }

  .icp-footer {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-size: 12px;
    color: #666;
    white-space: nowrap;

    a {
      color: #666;
      text-decoration: none;

      &:hover {
        color: #409eff;
        text-decoration: underline;
      }
    }
  }
}
</style>
